module.exports = __webpack_public_path__ + "static/media/logo.5886b146.svg";